import { toast } from 'react-toastify';
import api from '~/services/api';

export async function handleLogin(event, setLoading, login) {
  const logged = true;
  event.preventDefault();
  setLoading(true);
  await api
    .post('/Autenticar/Autenticacao', login)
    .then((response) => {
      const {
        accessToken,
        nomeUsuario,
        empresa,
        usuarioDesenvolvimento,
        usuarioSuporte,
        statusCode,
        message,
      } = response.data;
      if (statusCode === 401) {
        toast.error(message);
        return;
      }
      sessionStorage.setItem('@auth/token', accessToken);
      sessionStorage.setItem('@auth/userName', nomeUsuario);
      sessionStorage.setItem('@auth/empresa', empresa);
      sessionStorage.setItem('@auth/usuarioDev', usuarioDesenvolvimento);
      sessionStorage.setItem('@auth/usuarioSup', usuarioSuporte);
      toast.success('Bem vindo!');
      setLoading(false);
    })
    .catch(() => {
      toast.error('Falha no login. Verifique os dados e tente novamente');
      setLoading(false);
    });
  return logged;
}
